import { memo } from 'react';

import TableColumnClickableText from '@/components/ui/table/TableColumnClickableText';
import { truncateText } from '@bitstopco/bitstop-theme/helpers';

import { NOT_AVAILABLE } from '@/constants/app/config';
import type { MachineLocation } from '@/types';
import type { ClickableTextProps } from '@bitstopco/bitstop-theme';

type WithLocation = {
  location_id?: number;
  location?: MachineLocation;
};

type Props = {
  data: WithLocation;
  link?: boolean;
  fixIcon?: ClickableTextProps['fixIcon'];
  truncate?: ClickableTextProps['truncate'];
};

const TableColumnCashLogLocation = ({ data, link, fixIcon, truncate }: Props) => {
  const id = data.location_id || (data as any)?.atm?.location_id;
  const to = link ? `${window.location.origin}/location/${id}` : undefined;
  const text = data.location?.name ?? (data as any)?.full_address ?? NOT_AVAILABLE;
  const truncatedText = truncate ? truncateText(text, truncate) : text;

  if (!id) {
    return <>-</>;
  }
  return (
    <TableColumnClickableText
      sx={{
        '& h6': { maxWidth: 400, whiteSpace: 'normal', wordWrap: 'break-word' },
      }}
      id={id}
      to={to}
      text={truncatedText}
      fixIcon={fixIcon}
      clipboardValue={id}
      name="Location ID"
      overrideTooltipLinkText="Go to Location"
    />
  );
};

export default memo(TableColumnCashLogLocation);
